

const dataSlider = [
  {
    id: 0,
    title: "",
    img: "https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776301/VishvasWebsite/ABOUT%20US/OUR%20PROCESSES/SLIDESHOW%20C/agxvnc5zsk9ycpohfslu.jpg",

  },
  {
    id: 1,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776301/VishvasWebsite/ABOUT%20US/OUR%20PROCESSES/SLIDESHOW%20C/aldkilcuqkrb8ekk4bql.jpg",
  },
  {
    id: 2,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776300/VishvasWebsite/ABOUT%20US/OUR%20PROCESSES/SLIDESHOW%20C/biegdyvbrgyld5txgxlo.jpg",
  },
  {
    id: 3,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776301/VishvasWebsite/ABOUT%20US/OUR%20PROCESSES/SLIDESHOW%20C/rfmg6hke54p7yoesoymb.jpg",
  },
  {
    id:4,
    title: "",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679776301/VishvasWebsite/ABOUT%20US/OUR%20PROCESSES/SLIDESHOW%20C/l1ajns22k5fkcmdbalcq.jpg",
  },
  
 
];

export default dataSlider;
